<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
      <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#ffffff">
            <v-row
                align="center"
                justify="center"
                class="ma-0"
            >
                <v-col
                    cols="6"
                    sm="6"
                    md="3"
                    lg="3"
                    v-for="item in widgets"
                    :key="item.title"
                    class="pa-0"
                >
                    <v-card
                        class="mx-auto text-center" tile elevation="0" :to="item.link"
                    >
                        <v-list-item two-line>
                            <v-list-item-content class="pb-0">
                                <v-list-item-title class="text-h6">
                                {{ item.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle>{{ item.subtitle }}  <v-icon class="mr-1" color="green" v-if="item.icon == 'mdi-arrow-up-bold'">
                                        {{ item.icon }}
                                    </v-icon>
                                    <v-icon class="mr-1" color="red" v-else-if="item.icon == 'mdi-arrow-down-bold'">
                                        {{ item.icon }}
                                    </v-icon>
                                    <span class="subheading mr-2">{{ item.percentage }}%</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-card-text>
                            <v-row align="center">
                                <v-col
                                class="text-h2 pt-0 pb-0 count-up"
                                cols="12"
                                >
                                    <ICountUp
                                    :delay="delay"
                                    :endVal="item.total"
                                    :options="options"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-card
                class="mx-auto"
                flat
                tile
            >
                <v-toolbar
                color="#003a6f"
                dark
                flat
                >
                    <v-btn
                        color="primary"
                        @click="more = !more"
                        tile
                        v-if="!more"
                        large min-width="100%"
                        >
                            Show More Stats
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="more = !more"
                        tile
                        v-else
                        large min-width="100%"
                        >
                            <v-icon dark>mdi-close</v-icon> Hide More Stats
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-row
                align="center"
                justify="center"
                class="ma-0 dwidgets"
                v-if="more"
            >
                <Lbuser />
                <Lbshape />
                <Lbsize />
                <Cleaning />
            </v-row>
            <v-row
                align="center"
                justify="center"
                class="ma-0 dwidgets"
                v-if="more"
            >
                <Leads />
                <Jobs />
                <Wo />
            </v-row>
            <v-card
                class="mx-auto"
                flat
                tile
            >
                <v-toolbar
                color="#003a6f"
                dark
                flat
                v-if="user.id != 30"
                >
                    <v-toolbar-title>Admin Tasks</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        to="/newadmintask"
                        tile
                        >
                            <v-icon dark>mdi-plus</v-icon>
                            Add New
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card
                flat
                loader-height="10"
                tile
                min-width="100%"
                class="mt-0"
                v-if="user.id != 30"
            >
                <v-list two-line tile flat class="py-0 hover-list primary">
                    <v-list-item-group>
                        <template v-for="(job, index) in tasks">
                            <v-list-item
                            :key="`job-${index}`"
                            :value="job.id"                 
                            >
                                <template>
                                    <v-list-item-content @click.stop="openJob(job.id)">
                                        <v-list-item-title v-html="job.task" class="white--text"></v-list-item-title>
                                        <div>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="getColor(job.status)"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.status | capitalize }}
                                            </v-chip>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="getPriorityColor(job.priority)"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.priority | capitalize }}
                                            </v-chip>
                                            <v-chip
                                            class="mr-2 mb-1"
                                            :color="job.difference_color"
                                            text-color="white"
                                            small
                                            label
                                            >
                                            {{ job.difference }}
                                            </v-chip>
                                        </div>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-list-item-icon class="ma-0 mb-1 d-block">
                                            <div class="mb-1">
                                                <v-btn tile class="mr-1" elevation="0" color="light-green" dark :to="{ name:'Admin Task Edit', params:{id: job.id, tab: 'images'} }" width="85">
                                                    <v-icon dark class="mr-2">mdi-folder-multiple-image</v-icon> <span class="counter">{{ job.images.length }}</span>
                                                </v-btn>
                                            </div>
                                        </v-list-item-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                            <v-divider
                            :key="`dv-${index}`"
                            ></v-divider>
                        </template>
                    </v-list-item-group>  
                    <v-list-item v-if="pagination.total > 1" class="accent">
                        <v-list-item-content>
                            <v-pagination
                                v-model="pagination.current"
                                :length="pagination.total"
                                @input="onPageChange"
                                :total-visible="totalVisible"
                                dark
                            ></v-pagination>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
            <Drawer :show="drawer" @update-drawer="updateDrawer" />
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import authmixin from '../../mixin/auth.js'
    import ICountUp from 'vue-countup-v2'
    import Drawer from './SecretDrawer.vue'
    import Leads from '../../components/Charts/Leads.vue'
    import Jobs from '../../components/Charts/Jobs.vue'
    import Wo from '../../components/Charts/Wo.vue'
    import Lbshape from '../../components/Charts/LeadsByShape.vue'
    import Lbsize from '../../components/Charts/LeadsBySize.vue'
    import Lbuser from '../../components/Charts/LeadsByUser.vue'
    import Cleaning from '../../components/Charts/Cleaning.vue'

    export default {
        mixins: [authmixin],
        data: () => ({
            widgets: [],
            delay: 1000,
            drawer: false,
            more: false,
            pageTitle: 'Admin Dashboard',
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
            today: new Date().toISOString().substr(0, 10),
            focus: new Date().toISOString().substr(0, 10),
            type: 'month',
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            name: null,
            details: null,
            start: null,
            end: null,
            color: '#1976D2', // default event color
            currentlyEditing: null,
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            dialog: false,
            dialogDate: false,
            showmap: true,
            loading: false,
            downloadLoading: false,
            tasks: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            apiUrl: '',
            routeKey: '',
            filter: {
                job_no: "",
                keyword: "",
                status: ["active"],
                user: "all",
                county: "",
                priority: ["low", "medium", "high", "urgent"],
                daterange: "",
                order: false
            },
            total: 0,
        }),
        components: { Leads, Jobs, Wo, Lbshape, Lbsize, Lbuser, Drawer, ICountUp, Cleaning },
        computed: {
        },
        created() {
            this.$store.commit('data/SET_CUSTOMERS', [])
            this.$store.commit('data/SET_JOBS', [])
            this.$store.commit('data/SET_WORKORDERS', [])
        },
        mounted () {
            if (!this.access.includes(this.user.id)) {
                this.$router.push({ path: '/dashboard' })
            }
            this.getTasks()
            this.getWidgets()
        },
        methods: {
            async getWidgets() {
                this.loaded = false

                try {
                    await axios.get('crm/widgets')
                    .then(response => {
                        this.loaded = true
                        this.widgets = response.data
                        this.$nextTick()
                    })
                } catch (e) {
                    console.error(e)
                }
            },
            updateDrawer(val) {
                this.drawer = val
            },
            getTasks() {
                this.loading = true
                //this.drawer = false
                axios.get('crm/admin/tasks/get?page=' + this.pagination.current, {
                    params: this.filter
                })
                .then(response => {
                    this.loading = false
                    this.tasks = response.data.tasks
                    this.total = response.data.tasks.length
                    this.$nextTick()
                })
            },
            onPageChange() {
                this.getTasks()
                this.$vuetify.goTo(0)
            },
            openJob(id) {
                this.$router.push({ path: '/at/'+id })
            },
            dial (number) {
                window.location ='tel:'+number;
            },
            sendmail (address ){
                window.location = 'mailto:'+address;
            },
            googleLink (customer) {
                let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(customer.street_address+ ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip)
                window.open(link, "_blank") || window.location.replace(link)
            },
            updateJobNo(val) {
                this.filter.job_no = val
            },
            updateKeyword(val) {
                this.filter.keyword = val
            },
            updateStatus(val) {
                this.filter.status = val
                this.getTasks()
            },
            updateUser(val) {
                this.filter.user = val
                this.getTasks()
            },
            updateCounty(val) {
                this.filter.county = val
                this.getTasks()
            },
            updatePriority(val) {
                this.filter.priority = val
                this.getTasks()
            },
            updateDaterange(val) {
                this.filter.daterange = val
            },
            orderChange() {
                this.getTasks()
            },
            submitSearch() {
                this.getTasks()
            },
            getColor(status) {
                switch(status) {
                    case 'completed':
                        return 'green'
                    case 'active':
                        return 'light-blue'
                    case 'pending':
                        return 'orange'
                    case 'cancelled':
                        return 'red'
                    default:
                        // code block
                }
            },
            getPriorityColor(status) {
                switch(status) {
                    case 'low':
                        return 'light-blue'
                    case 'medium':
                        return 'green'
                    case 'high':
                        return 'orange'
                    case 'urgent':
                        return 'red'
                    default:
                        // code block
                }
            },
            setDialogDate( { date }) {
                this.dialogDate = true
                this.focus = date
            },
            viewDay ({ date }) {
                this.focus = date
                this.type = 'day'
            },
            getEventColor (event) {
                return event.color
            },
            showEvent ({ nativeEvent, event }) {
                this.$router.push('/job/main/' + event.id)
                nativeEvent.stopPropagation()
            },
            setToday () {
                this.focus = this.today
            },
            prev () {
                this.$refs.calendar.prev()
            },
            next () {
                this.$refs.calendar.next()
            },
            updateRange ({ start, end }) {
                this.start = start
                this.end = end
            },
            nth (d) {
                return d > 3 && d < 21
                ? 'th'
                : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
            },
        }
    }
</script>
<style lang="sass">
.v-content
    background: #003a6f

.dashboard-links
    padding: 4px
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 96px)/3)
            display: flex
            flex-wrap: wrap
            align-content: center
            justify-content: center

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important

.sub-widget
    min-height: 30px!important

.count-up
    font-weight: 500!important
    color: #001528!important

.mdi-arrow-down-bold + span
    color: #f44336!important

.mdi-up-down-bold + span
    color: #4caf50!important

.v-application .dwidgets .text-h6
    font-size: 1.05rem!important
</style>